export const tabs = [
    {
        path: "/restrain",
        className: "restrain",
        label: "Letiltások"
    },
    {
        path: "/restrainpartner",
        className: "restrainpartner",
        label: "Letiltásos partnerek"
    }
];